<script setup>
import { computed, watch, onUnmounted, getCurrentInstance } from 'vue';
import ContentTypeFieldEditForm from '../../common/content-type/ContentTypeFieldEditForm';
import ContentTypeNewAttributeBtn from '../../common/content-type/ContentTypeNewAttributeBtn';
import ContentTypeFieldsList from '../../common/content-type/ContentTypeFieldsList';
import ContentTypeFieldsetsList from "../../common/content-type/ContentTypeFieldsetsList.vue";
import ContentTypeNewFieldsetBtn from "../../common/content-type/ContentTypeNewFieldsetBtn.vue";
import ContentTypeFieldsetOffcanvas from "../../common/content-type/ContentTypeFieldsetOffcanvas.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const fieldsetId = computed(() => parseInt(proxy.$route.params.fieldsetId));
const fieldId = computed(() => parseInt(proxy.$route.params.fieldId));
const tableName = computed(() => proxy.$route.params.component);

const componentId = computed(() => {
    return store.state.components.componentIds[tableName.value];
});

const activeEditId = computed(() => store.state.componentFields.activeEditId);
const hasFieldsets = computed(() => store.state.fieldsets.items.length);
const activeFieldsetId = computed(() => store.state.componentFields.activeFieldsetId);

// --- Watchers ---

// Synchronize Route Params with Store State
watch(fieldsetId, (val) => {
    store.state.componentFields.activeFieldsetId = val;
}, { immediate: true });

watch(fieldId, (val) => {
    store.state.componentFields.activeEditId = val;
}, { immediate: true });

// Initialize fields when switching components (e.g., /users/fields -> /products/fields)
watch(componentId, (val) => {
    if (val) {
        store.dispatch('componentFields/init', { componentId: val });
    }
}, { immediate: true });

// Refresh fields if the active fieldset changes
watch(activeFieldsetId, () => {
    if (componentId.value) {
        store.dispatch('componentFields/init', { componentId: componentId.value });
    }
});

// --- Lifecycle ---

onUnmounted(() => {
    store.commit('componentFields/reset');
});
</script>

<template>
    <div class="pt-4 px-3 d-flex h-100 overflow-auto">
        <div class="row d-flex h-100 overflow-auto flex-fill">
            <template v-if="hasFieldsets">
                <div class="col-3 col-lg-2 pb-3 overflow-auto h-100">
                    <ContentTypeFieldsetsList class="mb-3"/>
                    <ContentTypeNewFieldsetBtn/>
                    <ContentTypeFieldsetOffcanvas/>
                </div>

                <div v-if="fieldsetId" class="col-3 col-lg-2 pb-3 overflow-auto h-100">
                    <ContentTypeFieldsList class="mb-3"/>
                    <ContentTypeNewAttributeBtn/>
                </div>

                <div class="col-6 col-lg-8 overflow-auto h-100">
                    <ContentTypeFieldEditForm v-if="activeEditId >= 0"/>
                </div>
            </template>

            <template v-else>
                <div class="col-sm-3 overflow-auto h-100">
                    <ContentTypeFieldsList/>
                    <ContentTypeNewAttributeBtn/>
                </div>

                <div class="col-sm-9 overflow-auto h-100">
                    <ContentTypeFieldEditForm v-if="activeEditId >= 0"/>
                </div>
            </template>
        </div>
    </div>
</template>

<style scoped>
.ghost {
    background: #666;
    border-color: #666;
    color: #fff;
}
</style>